import { render, staticRenderFns } from "./Voucher-Search.vue?vue&type=template&id=22c0ede4&scoped=true&"
import script from "./Voucher-Search.vue?vue&type=script&lang=js&"
export * from "./Voucher-Search.vue?vue&type=script&lang=js&"
import style0 from "./Voucher-Search.vue?vue&type=style&index=0&id=22c0ede4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c0ede4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c0ede4')) {
      api.createRecord('22c0ede4', component.options)
    } else {
      api.reload('22c0ede4', component.options)
    }
    module.hot.accept("./Voucher-Search.vue?vue&type=template&id=22c0ede4&scoped=true&", function () {
      api.rerender('22c0ede4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2q5k2RPyiYcYB/JS/comp/Voucher-Search.vue"
export default component.exports